<div class="filter-tray">
    <div class="tray-items" [formGroup]="byRegisteredForm">
        <div formArrayName="registeredUsers">
            <div class="tray-row" *ngFor="let userCtrl of registeredUsers.controls; let i = index">
                <single-choice
                    [formControl]="userCtrl"
                    (click)="setEditingIndex(i)"
                    [completedUrl]="completionUrl"
                    [topic]="'users'"
                    [editMode]="true"
                    [ticketId]="fakeId"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labelOnDemand]="registeredLabelerByService"
                    [choiceObserver]="registeredObserver">
                </single-choice>
                <button type="button" class="row-remove" (click)="removeField(i)" [disabled]="registeredUsers.length <= 1">
                    <i class="material-icons-outlined">close</i>
                </button>
            </div>
        </div>
    </div>
    <div class="tray-footer">
        <button type="button" class="add-btn" (click)="addUserField()">
            <i class="material-icons-outlined">add</i>
        </button>
        <not [filter]="byRegisteredFilter" (filterChanged)="onFilterChanged($event)"></not>
        <button class="apply-btn" type="button" (click)="apply()">{{ 'filter.apply' | translate }}</button>
    </div>
</div>
